import Ben from '../assets/interviewers/BenMurphy.jpg';
import CJ from '../assets/interviewers/CarlosJovel.jpg';
import RK from '../assets/interviewers/RedknotHQ.png';

export const INTERVIEWERS = {
	Ben,
	CJ,
	RK,
};
